import { __rest } from "tslib";
import * as React from 'react';
import Button from '@mui/material/Button';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { CdnIcon } from '@shared/ui';
const BackwardButton = (_a) => {
    var { classes, variant = 'icon', disableElevation = true, text = 'GoBack' } = _a, restProps = __rest(_a, ["classes", "variant", "disableElevation", "text"]);
    const { BackwardButton: theme } = useTheme('BaseComponents') || {};
    return (React.createElement(Button, Object.assign({ variant: 'text', classes: Object.assign(Object.assign({}, classes), { root: cn(theme.root, theme[variant], classes === null || classes === void 0 ? void 0 : classes.root) }), disableElevation: disableElevation }, restProps),
        (variant === 'icon' || variant === 'both') && (React.createElement(CdnIcon, { className: theme.arrowBackIcon, icon: "Arrow/Back" })),
        (variant === 'text' || variant === 'both') && text && React.createElement("div", { className: theme.arrowBackText }, text)));
};
export default BackwardButton;
